import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconOptAlt: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-filled-radius-0-stroke-1.5-IconOptAlt"><Path fillRule="evenodd" clipRule="evenodd" d="M15.3433 4.38769C15.4753 4.14852 15.7268 4 16 4H20.25C20.6642 4 21 4.33579 21 4.75C21 5.16421 20.6642 5.5 20.25 5.5H16.4428L8.65668 19.6123C8.52472 19.8515 8.27316 20 8 20H3.75C3.33579 20 3 19.6642 3 19.25C3 18.8358 3.33579 18.5 3.75 18.5H7.55722L15.3433 4.38769ZM15 19.25C15 18.8358 15.3358 18.5 15.75 18.5H20.25C20.6642 18.5 21 18.8358 21 19.25C21 19.6642 20.6642 20 20.25 20H15.75C15.3358 20 15 19.6642 15 19.25Z" fill="currentColor"/></CentralIconBase>;
});

export default IconOptAlt;
